import React, { FunctionComponent } from 'react';
import { Size } from 'app/components/presentation/buttons/ButtonClassNameA';
import { T } from 'app/components/localization';
import { CallStateConsumer } from 'app/containers/call/CallStateContext';
import LoadingState from 'app/containers/state/LoadingState';
import LoadingButtonA from 'app/components/presentation/buttons/LoadingButtonA';

interface IProps {
  pulse: boolean;
}

const ReadyButton: FunctionComponent<IProps> = (props) =>
  <CallStateConsumer>{({ unlock }) =>
    <T>{(t) =>
      <LoadingState load={unlock}>{({ isLoading, load }) =>
        <LoadingButtonA isLoading={isLoading} disabled={isLoading} onClick={load} size={Size.Tiny} {...props}>
          {t('lesson-booking-details.ready.button')}
        </LoadingButtonA>
      }</LoadingState>
    }</T>
  }</CallStateConsumer>;

export default ReadyButton;
